import React, { createContext, useContext, useState } from "react";
import api from "../api/axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("vrm_user");
    return raw ? JSON.parse(raw) : null;
  });

  async function login(username, password) {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("vrm_token", data.token);
    localStorage.setItem("vrm_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }

  async function loginWithOtp(username, otp) {
    const { data } = await api.post("/auth/verify-otp", { username, otp });
    localStorage.setItem("vrm_token", data.token);
    localStorage.setItem("vrm_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }

  function setAuthData(token, userData) {
    localStorage.setItem("vrm_token", token);
    localStorage.setItem("vrm_user", JSON.stringify(userData));
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem("vrm_token");
    localStorage.removeItem("vrm_user");
    sessionStorage.removeItem("sa_tab");
    sessionStorage.removeItem("spa_tab");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, loginWithOtp, setAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
